import {
  AdjustResult,
  AloftPrice,
  PairedSalesAnalysisFeature,
  StudiesPair,
  ToolkitStudyV1Request,
  isNumber,
  scalarToNumber,
} from '@aloft/toolkit-shared';

import { getTotalAdjustedValuePaired } from '../../adjustPairedSalesStandalone/getTotalAdjustedValuePaired.js';
import { isPairedSalesSqFtFeature } from '../types.js';
import { makeSqFtFeatureAdjustResultAndFormulaString } from './makeSqFtFeatureAdjustResultAndFormulaString.js';

// logic is from `runAdjustPairedSales`
export function makeAdjustResult(
  pair: StudiesPair,
  reconciledValue: ToolkitStudyV1Request['body']['reconciledValue'],
  feature: PairedSalesAnalysisFeature,
): AdjustResult {
  const p1Price = pair.p1.salePrice ?? AloftPrice.zero;
  const p2Price =
    getTotalAdjustedValuePaired(pair.p2.salePrice ?? AloftPrice.zero, pair.adjustments) ??
    AloftPrice.zero;

  const isPercent = isNumber(reconciledValue);
  if (isPercent) {
    return {
      t: 'percent',
      value: scalarToNumber(p1Price) / scalarToNumber(p2Price) - 1,
    };
  }

  if (isPairedSalesSqFtFeature(feature)) {
    const { result } = makeSqFtFeatureAdjustResultAndFormulaString({ feature, pair });
    return result;
  }

  return {
    t: 'absolute',
    value: p1Price.sub(p2Price),
  };
}
